const getCustomComponents = config => {
  const { CustomComponents = {} } = config;
  return CustomComponents;
};

export default getCustomComponents;
